<p-dialog
  [header]="itemName || 'Linked Drawing PDF'"
  [modal]="true"
  [(visible)]="dialogVisible"
  [style]="{ width: '85vw', height: '85vh' }"
  [appendTo]="'body'"
  [dismissableMask]="true"
  [closable]="true"
  (onHide)="onDialogHide()"
>
  <div class="flex gap-4" style="height: calc(85vh - 120px)">
    <div class="w-[50%] min-h-0 flex flex-col">
      @if (loading) {
        <div class="h-full flex flex-col items-center justify-center gap-3">
          <p-progress-spinner
            ariaLabel="Loading drawing details"
            strokeWidth="10"
          />
          <p class="text-sm text-muted-color">Loading drawing details...</p>
        </div>
      } @else if (errorMessage) {
        <p-message severity="error" styleClass="w-full">
          {{ errorMessage }}
        </p-message>
      } @else {
        <app-pdf-viewer [fileUrl]="drawingFile?.file_url ?? null" />
      }
    </div>

    <p-divider layout="vertical" />

    <div class="w-[50%] overflow-y-auto min-h-0">
      @if (loading) {
        <div class="flex flex-col p-2 pr-4">
          <p class="text-sm text-muted-color">
            Loading extracted drawing data...
          </p>
        </div>
      } @else if (drawingFile) {
        <app-drawing-extraction-info [drawingFile]="drawingFile" />
      } @else if (!errorMessage) {
        <div class="flex flex-col p-2 pr-4">
          <p class="text-sm text-muted-color">
            No extracted drawing data is available.
          </p>
        </div>
      }
    </div>
  </div>
</p-dialog>
